// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/fieldview-users/';
export const actions = [
  'SET_ALL_FIELDVIEW_USERS'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer(
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_ALL_FIELDVIEW_USERS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}

// Action Creators

export const setAllFieldViewUsers = (fieldViewUsers) => {
  return {
    type: actions.SET_ALL_FIELDVIEW_USERS,
    payload: fieldViewUsers
  };
};
